import { render, staticRenderFns } from "./PlantaTable.vue?vue&type=template&id=5eeb3eb8"
import script from "./PlantaTable.vue?vue&type=script&lang=js"
export * from "./PlantaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports